import { Injectable } from '@angular/core';
import { MatDateFormats } from '@angular/material/core';

type DisplayFormats = MatDateFormats['display'];
type ParseFormats = MatDateFormats['parse'];

@Injectable()
export class DynamicFormatDate implements MatDateFormats {
  private parseMap: ParseFormats = {
    dateInput: 'dd-MM-yyyy',
  };

  private displayMap: DisplayFormats = {
    dateInput: 'dd-MM-yyyy',
    monthLabel: 'MMMM',
    monthYearLabel: 'MMMM yyyy',
    monthYearA11yLabel: 'MMMM yyyy',
    dateA11yLabel: 'LL',
  };

  get parse(): ParseFormats {
    return this.parseMap;
  }

  get display(): DisplayFormats {
    return this.displayMap;
  }

  setDisplayFormat(format: string, formatType: keyof DisplayFormats): void {
    this.displayMap = {
      ...this.displayMap,
      [formatType]: format,
    };
  }
}
